import { render, staticRenderFns } from "./booking-list-skeleton.vue?vue&type=template&id=d3943bfe&scoped=true&"
import script from "./booking-list-skeleton.vue?vue&type=script&lang=js&"
export * from "./booking-list-skeleton.vue?vue&type=script&lang=js&"
import style0 from "./booking-list-skeleton.vue?vue&type=style&index=0&id=d3943bfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3943bfe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VDataTable,VIcon,VSkeletonLoader})
